import { useState } from 'react';
import { Upload, Button, message, Typography, Progress } from 'antd';
import { UploadOutlined, CustomerServiceOutlined, VideoCameraOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

const UploadMedia = ({ setMediaUrl, mediaUrl, accept = 'audio/*,video/*' }) => {
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState('');
    const [percent, setPercent] = useState(0);

    const beforeUpload = (file) => {
        const isMedia = file.type.startsWith('audio/') || file.type.startsWith('video/');
        if (!isMedia) {
            message.error("Faqat audio yoki video fayl yuklash mumkin!");
            return Upload.LIST_IGNORE;
        }
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
            message.error("Fayl hajmi 50MB dan kichik bo'lishi kerak!");
            return Upload.LIST_IGNORE;
        }
        return true;
    };

    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            setPercent(Math.round(info.file.percent || 0));
            return;
        }
        if (info.file.status === 'done') {
            setLoading(false);
            setPercent(100);
            const path = info.file.response?.data?.url;
            if (path) {
                setMediaUrl(path);
                setFileName(info.file.name);
                message.success("Fayl muvaffaqiyatli yuklandi");
            }
        }
        if (info.file.status === 'error') {
            setLoading(false);
            setPercent(0);
            message.error("Faylni yuklashda xatolik yuz berdi");
        }
    };

    const handleRemove = () => {
        setMediaUrl('');
        setFileName('');
        setPercent(0);
    };

    const isAudio = mediaUrl && (mediaUrl.includes('.mp3') || mediaUrl.includes('.wav') || mediaUrl.includes('.ogg') || mediaUrl.includes('.m4a'));
    const isVideo = mediaUrl && (mediaUrl.includes('.mp4') || mediaUrl.includes('.webm') || mediaUrl.includes('.mov'));

    return (
        <div>
            {!mediaUrl ? (
                <div>
                    <Upload
                        name="file"
                        showUploadList={false}
                        action={process.env.REACT_APP_API_URL + "/upload/media"}
                        headers={{
                            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                        }}
                        accept={accept}
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                    >
                        <Button
                            icon={<UploadOutlined />}
                            loading={loading}
                            size="large"
                            style={{
                                borderRadius: 10,
                                borderStyle: 'dashed',
                                height: 48,
                                paddingInline: 24,
                            }}
                        >
                            {loading ? 'Yuklanmoqda...' : "Audio yoki video yuklash"}
                        </Button>
                    </Upload>
                    {loading && <Progress percent={percent} size="small" style={{ maxWidth: 250, marginTop: 8 }} />}
                </div>
            ) : (
                <div style={{
                    padding: 12,
                    background: 'var(--qk-bg-soft)',
                    borderRadius: 10,
                    border: '1px solid #f0f0f0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            {isAudio ? (
                                <CustomerServiceOutlined style={{ fontSize: 18, color: '#667eea' }} />
                            ) : (
                                <VideoCameraOutlined style={{ fontSize: 18, color: '#667eea' }} />
                            )}
                            <Text ellipsis style={{ maxWidth: 220 }}>
                                {fileName || mediaUrl.split('/').pop()}
                            </Text>
                        </div>
                        <Button
                            type="text"
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={handleRemove}
                        />
                    </div>

                    {isAudio && (
                        <audio controls style={{ width: '100%', height: 36 }}>
                            <source src={process.env.REACT_APP_URL + mediaUrl} />
                        </audio>
                    )}
                    {isVideo && (
                        <video controls style={{ width: '100%', maxHeight: 180, borderRadius: 8 }}>
                            <source src={process.env.REACT_APP_URL + mediaUrl} />
                        </video>
                    )}
                </div>
            )}
        </div>
    );
};

export default UploadMedia;
